export default __webpack_public_path__ + "static/media/whiteWomen8.11059da2.svg";